import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class RouteInformation extends React.Component {
  render() {
    return (
      <tr style={{ color: 'white', backgroundColor: '#e7158d' }}>
        <th scope="row">{this.props.route.ZIP_CODE || '-'}-{this.props.route.CRID_ID || ''}</th>
        <td>{this.props.route.RES_CNT || '--'}</td>
        <td>{this.props.route.BUS_CNT || '--'}</td>
        <td>{this.props.route.TOT_CNT || '--'}</td>
        <td>{this.props.route.AVG_HH_SIZ ? this.props.route.AVG_HH_SIZ.toFixed(2) : '--'}</td> 
        <td>
  {this.props.route.MED_INCOME
    ? `$${(this.props.route.MED_INCOME * 1).toLocaleString()}`
    : '--'}
</td>
      </tr>);
  }
}

function mapStateToProps(state, ownProps) {
  return {
    route: state.hoveredRoute
  };
}

function mapDispatchToProps(dispatch) {
  return {

  };
}

RouteInformation.propTypes = {
  route: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteInformation);